import { render, staticRenderFns } from "./ServiceConfigContainer.vue?vue&type=template&id=36bbd576&"
import script from "./ServiceConfigContainer.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports